import React from "react";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Routes from "./routes/Routes";
import { AuthProvider } from "./hooks/useAuth";

function App() {
  return (
    <AuthProvider>
      <DndProvider backend={HTML5Backend}>
        <Routes />
        <ToastContainer position="top-right" autoClose={5000} theme="light" />
      </DndProvider>
    </AuthProvider>
  );
}

export default App;